import { Button, Checkbox } from '../../common'
import React from 'react'
import ContactImg from '../../../assets/contact-img.webp'
import TextInputField from '../../common/TextInputField'
import ReCAPTCHA from 'react-google-recaptcha'
import { Suspense, useEffect, useState } from 'react'
import { PopupContactRequest } from '../../Popups/PopupContactRequest'
import leadApi from '../../../store/reducers/leads/leadApi'
import { ILead } from '../../../interfaces/lead'
import { Cookies } from 'react-cookie'
import IconLoading from '../../../assets/loading-gif.gif'
import {
  DATE_ENTRY,
  DEVICE_ID,
  EMAIL,
  FORM_INFOS_CONTACT_LEAD,
  ID_PRODUCT_SEARCHED_VIEWED
} from '../../../constants/storageNames'
import Logo from '../../../assets/glemo-logo.webp'
import { v4 } from 'uuid'
import SkeletonLoading from '../../common/SkeletonLoading'
import {
  getInputValueFromForm,
  getLeadFormValidationError,
  isLocal,
  isValidStr
} from '../../../common_functions'
import { useAuth } from '../../../hooks/useAuth'
import { IRequestCreate } from '../../../store/reducers/users/interfaces/IRequestApi'
import userApi from '../../../store/reducers/users/userApi'
import { USERINFOS } from '../../../constants/loginInfos'
import generalApi from '../../../store/reducers/general/generalApi'
import { IProductSearchedViewedUpdt } from '../../../interfaces/productSearchedViewed'
interface Props {
  showModal: boolean
  enterpriseId: string
  constructionId: string
  closeModal: () => void
}

export function ModalFormContact({ showModal, closeModal, enterpriseId, constructionId }: Props) {
  const auth = useAuth()
  const cookies = new Cookies()
  const deviceId = cookies.get(DEVICE_ID)
  const navigationStartDate = sessionStorage.getItem(DATE_ENTRY) ?? ''
  const formInfosLocal: IRequestCreate = JSON.parse(
    localStorage.getItem(FORM_INFOS_CONTACT_LEAD) &&
      localStorage.getItem(FORM_INFOS_CONTACT_LEAD)?.toString() != 'undefined'
      ? localStorage.getItem(FORM_INFOS_CONTACT_LEAD) ?? '{}'
      : '{}'
  )
  const uuid = v4()
  const [disabledBtn, setDisabledBtn] = useState<boolean>(!isLocal())
  const userInfos = Array.isArray(auth.loginUser) ? auth.loginUser[0] : auth.loginUser
  const isLogged = isValidStr(userInfos?.User?.Id)
  const typeLeadSourceIdTenhoIntesse = 'ACB81872-EA1E-4AD0-B54E-80B555E49AE0'
  const statusLead = 'DCF1D21E-8319-4B94-BF64-96B86213F0C7'
  const [isNewAccount, setIsNewAccount] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const [statusMessage, setStatusMessage] = useState('loading')
  const [messagePopup, setMessagePopup] = useState<string | undefined>(undefined)
  const [validationError, setValidationError] = useState<string | null>(null)
  const constructionsIdIncludesRenda = [
    '84256131-16F3-48BB-97E2-69127BCA4B00',
    'AB5609AA-3CF3-4075-273D-08DCA030D451',
    '7E850AAD-29EE-47ED-BC78-648607A22666'
  ]

  const [
    useUpdtProductSearchedViewed,
    {
      data: dataProductSearched,
      isLoading: isLoadingProductSearched,
      isError: isErrorProductSearched,
      isSuccess: isSuccessProductSearched
    }
  ] = generalApi.useLazyGetProductSearchedViewedQuery()
  const [content, setContent] = useState<ILead>({
    statusLead: statusLead,
    name: formInfosLocal?.fullName ?? '',
    cpf: '',
    income: '',
    email: formInfosLocal?.email ?? '',
    phone: formInfosLocal?.phoneNumber ?? '',
    enterpriseId: enterpriseId,
    constructionCompanyId: constructionId,
    typeLeadSourceId: typeLeadSourceIdTenhoIntesse,
    metadata: {
      redirectionSourceUrl: uuid,
      navigationStartDate: navigationStartDate,
      urlSubmittedForm: location.href,
      deviceId: parseInt(deviceId),
      enterpriseId: enterpriseId,
      traceId: uuid,
      allowDirectContact: true
    }
  })

  const [
    useAddLeads,
    { isError: isErrorAddLead, isLoading: isLoadingAddLead, error, isSuccess: isSuccessAddLead }
  ] = leadApi.useAddLeadMutation()

  const [
    useCreateUser,
    {
      data: dataCreateUser,
      error: errorCreateUser,
      isError: isErrorCreateUser,
      isLoading: isLoadingCreateUser,
      isSuccess: isSuccessCreateUser
    }
  ] = userApi.useCreateUserMutation()

  useEffect(() => {
    let body: HTMLElement | null = document.querySelector('body')

    if (body != null) {
      if (showModal) {
        body.setAttribute('style', 'overflow-y: hidden')
      } else {
        body.setAttribute('style', 'overflow-y: auto')
      }
    }
  }, [showModal])

  const createUser = async (lead: ILead) => {
    let newUserCreate: IRequestCreate = {
      email: lead.email,
      fullName: lead.name,
      phoneNumber: lead.phone
    }

    await useCreateUser(newUserCreate)
  }

  const updtProductSearchedViewed = async () => {
    const id = sessionStorage.getItem(ID_PRODUCT_SEARCHED_VIEWED)
    if (id) {
      await useUpdtProductSearchedViewed(id)
    }
  }

  useEffect(() => {
    if (isSuccessProductSearched) {
      sessionStorage.removeItem(ID_PRODUCT_SEARCHED_VIEWED)
    }
  }, [isSuccessProductSearched])

  const handleSendMessage = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const leadPreenchido = getLeadFromForm(event.currentTarget)
    setContent(leadPreenchido)

    const errorMessage = getLeadFormValidationError(leadPreenchido, !disabledBtn)
    setValidationError(errorMessage)
    if (errorMessage) return

    setShowPopup(true)
    await sendLead(leadPreenchido)
    await updtProductSearchedViewed()
    if (!isLogged) {
      await createUser(leadPreenchido)
    }
  }

  const getLeadFromForm = (form: HTMLFormElement): ILead => {
    return {
      ...content,
      name: getInputValueFromForm(form, 'name') || content.name.trim(),
      email: getInputValueFromForm(form, 'email') || content.email.trim(),
      phone: getInputValueFromForm(form, 'phone-number') || content.phone,
      income: getInputValueFromForm(form, 'renda') || content.income
    }
  }

  const sendLead = async (lead: ILead) => {
    var newPhone = lead.phone.replace('(', '').replace(')', '').replace(' ', '').replace('-', '')
    await useAddLeads({ ...lead, phone: newPhone.slice(0, 11) })
  }

  useEffect(() => {
    if (!isLoadingAddLead && !isLoadingCreateUser && !isLoadingProductSearched) {
      const contentLead: IRequestCreate = {
        fullName: content.name,
        email: content.email,
        phoneNumber: content.phone
      }
      localStorage.setItem(FORM_INFOS_CONTACT_LEAD, JSON.stringify(contentLead))

      if (isSuccessAddLead || isErrorAddLead) setShowPopup(true)
      if (isLogged) {
        if (isSuccessAddLead) setStatusMessage('success')
        if (isErrorAddLead) setStatusMessage('error')
      } else {
        if (isSuccessAddLead && (isSuccessCreateUser || isErrorCreateUser)) {
          setStatusMessage('success')
          if (isSuccessCreateUser) {
            setMessagePopup(
              'Oba! Agora você faz parte do glemO, confirme sua conta no e-mail cadastrado para ver sua jornada completa nesse empreendimento. A construtora entrará em contato em breve. Se construtora não entrar em contato nós cuidaremos de você!'
            )
          }
          if (isErrorCreateUser) {
            setMessagePopup(
              `Oba! A construtora entrará em contato em breve. Se construtora não entrar em contato nós cuidaremos de você!`
            )
          }
        }
        if (isErrorAddLead) {
          setStatusMessage('error')
        }
      }
    }
  }, [
    isSuccessAddLead,
    isLoadingCreateUser,
    isLoadingProductSearched,
    isLoadingAddLead,
    isErrorAddLead,
    isSuccessCreateUser,
    isErrorCreateUser
  ])

  // useEffect(() => {
  //   if (isSuccessAddLead) setStatusMessage('success')
  // }, [isSuccessAddLead])

  // useEffect(() => {
  //   if (isErrorAddLead) {
  //     setStatusMessage('error')
  //   }
  // }, [isErrorAddLead])

  const handleCheckedContatoDireto = () => {
    let checkboxHTML = document.querySelector('#checkboxModalFormContact') as HTMLElement
    let isChecked = false
    if (checkboxHTML != undefined) {
      isChecked = checkboxHTML.getAttribute('aria-checked') === 'false'
    }
    let metadaAux = content.metadata
    metadaAux.allowDirectContact = isChecked
    setContent({ ...content, metadata: metadaAux })
  }

  function handleChangeStatusModalPopup() {
    setShowPopup(false)
    setTimeout(() => {
      closeModal()
    }, 200)
    setStatusMessage('loading')
    setMessagePopup(undefined)
  }

  useEffect(() => {
    const btncloseModalFormContact = document.querySelector('#closeModalFormContact') as HTMLElement
    btncloseModalFormContact?.addEventListener('click', closeModal)
  }, [closeModal])

  useEffect(() => {
    const headerHTML = document.querySelector(
      window.screen.width <= 768 ? '.header-mobile' : 'header'
    ) as HTMLElement
    const carouselEnterpriseHTML = document.querySelector('.carousel-enterprise') as HTMLElement
    if (showModal) {
      if (headerHTML != undefined) {
        headerHTML?.classList.remove('z-[99]')
      }
      if (carouselEnterpriseHTML != undefined) {
        carouselEnterpriseHTML?.classList.remove('z-0')
        carouselEnterpriseHTML.style.zIndex = '-2'
      }
    } else {
      if (headerHTML != undefined) {
        headerHTML?.classList.add('z-[99]')
      }
      if (carouselEnterpriseHTML != undefined) {
        carouselEnterpriseHTML?.classList.add('z-0')
        carouselEnterpriseHTML.style.zIndex = '0'
      }
    }
  }, [showModal])

  function onChange(value: any) {
    if (value) {
      setDisabledBtn(false)
    }
  }

  return (
    <>
      {showModal ? (
        <>
          <div className="modal-form-contact justify-center items-center md:flex overflow-x-hidden fixed inset-0 z-[1000] outline-none focus:outline-none md:rounded-lg m-auto">
            <div className="relative w-auto mx-auto h-[100%] lg:h-auto  max-w-[100%]">
              <div className="container-modal border-0 md:rounded-lg h-[100%] md:h-auto shadow-xl relative flex flex-col bg-white outline-none focus:outline-none p-4 overflow-y-auto w-full md:w-[553px] max-w-[100%] md:max-h-screen">
                <div className="lg:grid md:grid-cols-5">
                  <div className="col-span-2">
                    <div
                      className="bg-cover bg-no-repeat bg-center h-full w-full"
                      style={{ backgroundImage: `url(${ContactImg})` }}
                    ></div>
                  </div>
                  <div className="col-span-3">
                    <div className="flex justify-between pt-5 md:hidden">
                      <div className=" text-glemo-blue flex align-middle">
                        {/* <X size={25} className="text-glemo-blue" id='closeModalMenuMobile'></X> */}
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="cursor-pointer"
                          onClick={closeModal}
                        >
                          <path
                            id="Vector"
                            d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
                            fill="#F15C00"
                          />
                        </svg>
                      </div>
                      <div className="m-auto">
                        <Suspense fallback={<SkeletonLoading />}>
                          <img alt="Logo do Glemo" src={Logo} className="w-[130px] max-w-full" />
                        </Suspense>
                      </div>
                      <div></div>
                    </div>
                    <div
                      className="flex items-start justify-between md:p-5 roun
                    ded-t"
                    >
                      <h3 className="text-2xl font-semibold hidden md:block">
                        Cadastre seu contato para acionar a construtora.
                      </h3>
                      <h5 className="md:hidden text-center text-lg mt-5">
                        A construtora vai entrar em contato em breve. Se construtora não entrar em
                        contato nós cuidaremos de você.
                      </h5>
                      <button
                        className="p-1 ml-auto hidden md:block bg-transparent border-0 float-right leading-none font-semibold outline-none focus:outline-none"
                        id="closeModalFormContact"
                      >
                        <span className="bg-transparent h-6 w-6 outline-none focus:outline-none">
                          {/* <X color="black" size={20} weight="bold" /> */}
                          <svg
                            width={20}
                            fill="black"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 256 256"
                          >
                            <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
                          </svg>
                        </span>
                      </button>
                    </div>
                    {/*body*/}
                    <div className="relative p-6 pt-2 flex-auto">
                      <form method="post" onSubmit={handleSendMessage}>
                        <div className="grid grid-rows-1 gap-4">
                          {/* <SelectField
                            name="subject"
                            label="Assunto"
                            options={['Financeiro', 'Parcerias', 'Suporte', 'Comercial', 'Outros']}
                          /> */}
                          <TextInputField
                            name="name"
                            label="Nome*"
                            required
                            defaultValue={content.name}
                            setInput={(val) => setContent({ ...content, name: val })}
                          />
                          {/* <TextInputField
                            name="cpf"
                            label="CPF*"
                            required
                            type="number"
                            setInput={(val) => setContent({ ...content, cpf: val })}
                            maxLength={11}
                          /> */}
                          <TextInputField
                            name="email"
                            label="E-mail*"
                            required
                            type="email"
                            defaultValue={content.email}
                            setInput={(val) => setContent({ ...content, email: val })}
                          />
                          <TextInputField
                            name="phone-number"
                            label="Telefone"
                            defaultValue={content.phone}
                            maskPhoneNumber
                            setInput={(val) => setContent({ ...content, phone: val })}
                          />
                          {constructionsIdIncludesRenda.includes(constructionId.toUpperCase()) && (
                            <TextInputField
                              name="renda"
                              label="Renda"
                              defaultValue={content.income}
                              maskPrice
                              setInput={(val) => setContent({ ...content, income: val })}
                            />
                          )}
                        </div>
                        {/* <SelectField name="contact" label="Com quem vou conversar?" /> */}
                        <div>
                          <div className="flex">
                            <Checkbox.Root
                              id="checkboxModalFormContact"
                              className="m-auto ml-0 mr-3 h-[18px]"
                              variant="orange"
                              onClick={handleCheckedContatoDireto}
                            >
                              <Checkbox.Indicator>
                                {/* <Check color="#ffffff" size={12} weight="bold" /> */}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  fill="#ffffff"
                                  viewBox="0 0 256 256"
                                >
                                  <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
                                </svg>
                              </Checkbox.Indicator>
                            </Checkbox.Root>
                            <small className="font-semibold text-black text-lg my-4">
                              Este número é meu WhatsApp e permito o contato direto
                            </small>
                          </div>
                        </div>
                        <div  style={{transform: 'scale(0.9)', transformOrigin: 'left top'}}>
                          <ReCAPTCHA
                            sitekey="6LeCvu8pAAAAAIDJt1wUUvPkKN6y-7QvDZnjl5Ln"
                            onChange={onChange}
                          />
                        </div>
                        <div className="my-4">
                          {isNewAccount && (
                            <div
                              className="bg-orange-50 border-l-4 border-orange-500 text-orange-700 p-4"
                              role="alert"
                            >
                              <p>
                                Verifique seu e-mail, confirme sua conta, depois atualize a página e
                                demonstre interesse nos empreendimentos.
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="text-center mt-4">
                          <p className="text-base font-semibold text-gray-600 leading-[22px]">
                            Ao enviar seus dados para a construtora, automaticamente você estará
                            aceitando nossos{' '}
                            <span>
                              <a href="/termos-de-uso" className="text-blue-700 underline">
                                termos de uso
                              </a>
                            </span>{' '}
                            da plataforma
                          </p>
                        </div>
                        {validationError && (
                          <div
                            className="mt-4 bg-[#FEF2F2] border-l-4 border-[#DC2626] text-[#B91C1C] p-3 text-sm"
                            role="alert"
                          >
                            {validationError}
                          </div>
                        )}
                        <div className="flex items-center justify-center mt-5">
                          <Button
                            disabled={disabledBtn}
                            variant="orange"
                            type="submit"
                            id="sendMessageModalFormContact"
                            className="ml-3 font-bold w-full btn-submit-modal-form-contact"
                          >
                            ENVIAR INFORMAÇÕES{' '}
                            {isLoadingCreateUser || isLoadingAddLead ? (
                              <img src={IconLoading} width={15} />
                            ) : (
                              <></>
                            )}
                          </Button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-[100] bg-black"></div>
        </>
      ) : null}
      <>
        {/* POPUP */}
        <PopupContactRequest
          status={statusMessage}
          showPopup={showPopup}
          message={messagePopup}
          closePopup={handleChangeStatusModalPopup}
        />
      </>
    </>
  )
}
